'use client';

import { useTranslations } from 'next-intl';

import { Button, Typography } from '@/components/atoms';
import { Modal } from '@/components/molecules';
import { cn } from '@/lib/utils/tailwind';

export interface ApprovalModalProps {
  modalOpen: boolean;
  modalOpenAction: (open: boolean) => void;
  modalTitle?: string;
  modalSubtitle: string;
  modalCTA: string;
  onConfirm?: () => void;
}

export const ApprovalModal = ({
  modalOpen,
  modalOpenAction,
  modalTitle,
  modalSubtitle,
  modalCTA,
  onConfirm,
}: ApprovalModalProps) => {
  const t = useTranslations();
  const handleDeletePlaylist = () => {
    onConfirm?.();
  };

  return (
    <Modal.Root
      isOpen={modalOpen}
      onOpenChange={modalOpenAction}
      className={cn(
        'max-w-[320px] w-full overflow-auto max-h-full p-0 bg-(--color-surface-default)',
      )}
    >
      <Modal.Header className="border-0 p-2 justify-end ">
        <Modal.Title className="w-full text-left px-1">
          {modalTitle}
        </Modal.Title>
        <Modal.Description className="sr-only">
          {modalSubtitle}
        </Modal.Description>
        <Modal.Close />
      </Modal.Header>
      <Modal.Body className="p-3 flex flex-col items-center">
        <Typography.Text variant="paragraph" size="md" weight="medium">
          {modalSubtitle}
        </Typography.Text>
        <div className="flex flex-row items-center justify-around mt-2 mb-2 w-full">
          <Button
            size="sm"
            variant="primary"
            className="mt-2 w-auto text-center"
            onClick={() => modalOpenAction(false)}
          >
            {t('MOBILE_WEBPLAYER_CANCEL')}
          </Button>
          <Button
            size="sm"
            variant="error"
            className="mt-2 w-auto text-center"
            onClick={handleDeletePlaylist}
          >
            {modalCTA}
          </Button>
        </div>
      </Modal.Body>
    </Modal.Root>
  );
};
